var _circle, _circle2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcColoredCategoryIncome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 31,
    r: 30,
    fill: "white",
    stroke: "#DFE2EB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_565_13423",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 60,
    height: 60
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 31,
    r: 30,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_565_13423)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.3535 22.4116V35.3354C33.3535 38.5934 28.7914 40.0587 25.1182 40.0587C21.4451 40.0587 16.8829 38.5934 16.8829 35.3354V22.4116",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3535 22.4116V35.3354C33.3535 38.5934 28.7914 40.0587 25.1182 40.0587C21.4451 40.0587 16.8829 38.5934 16.8829 35.3354V22.4116",
    stroke: "#20242E",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3535 25.9414C33.3535 28.5402 29.6663 30.6473 25.1182 30.6473C20.5709 30.6473 16.8829 28.5402 16.8829 25.9414",
    stroke: "#20242E",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.3535 22.4122C33.3535 24.361 29.6663 25.9411 25.1182 25.9411C20.5709 25.9411 16.8829 24.361 16.8829 22.4122C16.8829 20.4625 20.5709 18.8823 25.1182 18.8823C29.6663 18.8823 33.3535 20.4625 33.3535 22.4122Z",
    fill: "white",
    stroke: "#20242E",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3535 30.647C33.3535 33.2457 29.6663 35.3529 25.1182 35.3529C20.5709 35.3529 16.8829 33.2457 16.8829 30.647",
    stroke: "#20242E",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.0156 22.4116C31.0156 21.4428 27.7249 20.6572 25.117 20.6572C22.5096 20.6572 19.2185 21.4428 19.2185 22.4116C19.2185 23.3809 22.5096 24.1665 25.117 24.1665C27.7249 24.1665 31.0156 23.3809 31.0156 22.4116Z",
    fill: "#0E5CF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.851 26.9155C38.851 26.9155 33.32 29.0295 26.4082 28.331C27.2004 32.4318 29.5036 40.1268 33.7586 42.8755C35.7956 44.4272 40.3489 45.7793 40.3489 40.1047C42.7631 40.7697 47.4289 41.745 50.0543 40.3263C42.4723 39.1072 39.6432 31.0164 38.851 26.9155Z",
    fill: "white",
    stroke: "#20242E",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_565_13423)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.5887 38.13L37.0202 35.7165C37.7537 35.7698 38.5227 36.143 38.8875 36.7C39.2522 37.2569 39.1035 37.812 38.6071 38.1301M35.4645 34.8353C34.6573 34.866 33.8333 34.5094 33.4685 33.9524C33.1037 33.3955 33.3443 32.8239 33.9872 32.5569L35.4645 34.8353ZM33.2239 30.6515C32.9852 30.7011 32.8927 30.9197 33.057 31.1391L33.3488 31.578C32.1184 31.9944 31.6926 33.0704 32.4039 34.1505C33.1153 35.2307 34.6719 35.8931 36.0662 35.7804L37.7442 38.3458C36.9371 38.3765 36.0765 37.9692 35.6753 37.3448C35.5112 37.0748 35.1266 36.9218 34.8513 36.9713C34.576 37.0208 34.465 37.2898 34.6474 37.5599C35.3952 38.6907 36.9883 39.4205 38.3826 39.3078L38.6745 39.7467C38.8204 39.9661 39.15 40.1188 39.3886 40.0692C39.6272 40.0196 39.7015 39.7841 39.5555 39.5647L39.2638 39.109C40.3292 38.6584 40.6267 37.5651 39.9337 36.4849C39.2407 35.4048 37.7394 34.6753 36.4004 34.704L34.9048 32.4087C35.62 32.445 36.3708 32.7845 36.6808 33.2739C36.8448 33.5439 37.211 33.7137 37.5047 33.6474C37.7985 33.5811 37.8728 33.3288 37.6903 33.0756C36.997 32.0629 35.5505 31.4009 34.2114 31.4296L33.9197 30.974C33.7737 30.7545 33.4624 30.6187 33.2239 30.6515Z",
    fill: "#0E5CF4"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M35.2695 43.7494C37.5068 45.1262 44.1111 45.3753 49.912 40.3989",
    stroke: "#20242E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.3547 22.0034L44.4713 23.0106C44.5808 23.9577 45.3125 24.7133 46.2556 24.8533C45.3127 24.9921 44.5808 25.7471 44.4713 26.6938L44.3547 27.7012L44.2395 26.6908C44.1316 25.7444 43.3997 24.9894 42.457 24.8523C43.4001 24.713 44.1317 23.9569 44.2398 23.0097L44.3547 22.0034Z",
    fill: "#0E5CF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0273 12.416L40.2749 14.4673C40.5348 16.6207 42.2091 18.3308 44.3565 18.6363C42.2096 18.9393 40.5348 20.6481 40.2749 22.8007L40.0273 24.8525L39.7824 22.7942C39.5263 20.6422 37.8515 18.9335 35.7051 18.6343C37.8526 18.3301 39.5265 16.6188 39.7831 14.4652L40.0273 12.416Z",
    fill: "#0E5CF4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_565_13423"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.23529,
    height: 9.41176,
    fill: "white",
    transform: "translate(32.0684 30.647) rotate(0.211122)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcColoredCategoryIncome);
export default __webpack_public_path__ + "static/media/ic-colored-category-income.d91d7347c0d06ffd3d84bc12546f3750.svg";
export { ForwardRef as ReactComponent };